<div class="flex gap-2">
  <button pButton pRipple type="button"
          class="flex-1 min-w-0 flex flex-column justify-content-center gap-3 p-3 p-button-outlined p-button-plain border-round"
          (click)="choose('profile')">
    <i class="pi pi-user text-4xl text-primary" aria-hidden="true"></i>
    <span class="font-semibold text-color text-center line-height-3">{{ 'shared.modal.modal_service.avatar_actions.profile' | translate }}</span>
  </button>
  <button pButton pRipple type="button"
          class="flex-1 min-w-0 flex flex-column justify-content-center gap-3 p-3 p-button-outlined p-button-plain border-round"
          (click)="choose(secondaryAction)">
    <i class="pi text-4xl text-primary" [class.pi-camera]="secondaryAction === 'photos'" [class.pi-car]="secondaryAction === 'garage'" aria-hidden="true"></i>
    <span class="font-semibold text-color text-center line-height-3">{{ ('shared.modal.modal_service.avatar_actions.' + secondaryAction) | translate }}</span>
  </button>
</div>
